import { render, staticRenderFns } from "./Upgrader.vue?vue&type=template&id=6c48d30f&scoped=true"
import script from "./Upgrader.vue?vue&type=script&lang=js"
export * from "./Upgrader.vue?vue&type=script&lang=js"
import style0 from "./Upgrader.vue?vue&type=style&index=0&id=6c48d30f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48d30f",
  null
  
)

export default component.exports